module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_semi grid_deskstop.2151b0ff.jpg";